import { IssueSubtypes200Response, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';

export type UseInfiniteIssueSubtypesParamsObject = {
  page?: number;
  limit?: number;
  sortByName?: 'asc' | 'desc';
  filterById?: string;
  filterByName?: string;
  filterByEnabled?: boolean;
  filterByIssueTypeManager?: boolean;
  filterByIssueTypes?: string[];
};

export interface UseInfiniteIssueSubtypesParams {
  params?: UseInfiniteIssueSubtypesParamsObject;
  enabled?: boolean;
  handleError?: boolean;
}

export function useInfiniteIssueSubtypes({
  params = {},
  enabled = true,
  handleError = false,
}: UseInfiniteIssueSubtypesParams) {
  const {
    page = 0,
    limit = 10,
    sortByName,
    filterById,
    filterByName,
    filterByEnabled,
    filterByIssueTypeManager,
    filterByIssueTypes = [],
  } = params;

  const api = useApi();

  const queryKey = [
    'issue-subtypes',
    page,
    limit,
    sortByName,
    filterById,
    filterByName,
    filterByEnabled,
    filterByIssueTypeManager,
    filterByIssueTypes,
    enabled,
  ];

  return useInfiniteQuery<
    IssueSubtypes200Response,
    ExtendedAxiosError,
    InfiniteData<IssueSubtypes200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueSubtypesApi
        .issueSubtypes(
          pageParam,
          limit,
          sortByName,
          filterById,
          filterByName,
          filterByEnabled,
          filterByIssueTypeManager,
          filterByIssueTypes.length > 1 ? filterByIssueTypes : undefined,
          filterByIssueTypes.length === 1 ? filterByIssueTypes[0] : undefined,
        )
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
    meta: {
      handleError,
    },
  });
}
